import { TextField, useTheme } from "@mui/material";

export type ResultFieldState = "neutral" | "error" | "success";

type ResultFieldProps = {
  state: ResultFieldState;
  id: string;
  result: any;
};

export const ResultField = ({ state, id, result }: ResultFieldProps) => {
  const theme = useTheme();
  return (
    <TextField
      data-testid={`result-${id}-textbox`}
      data-state={state}
      label="Result"
      multiline
      rows={3}
      value={result === null ? "" : JSON.stringify(result, null, 2)}
      focused
      sx={{
        "height": "100%",
        "& label.Mui-focused": {
          color:
            state === "error"
              ? theme.palette.cedeErrorColor
              : state === "success"
              ? theme.palette.text.primary
              : theme.palette.primaryDarkBlue,
        },
        "& .MuiOutlinedInput-root": {
          "height": "100%",
          "&.Mui-focused fieldset": {
            borderColor:
              state === "error"
                ? theme.palette.cedeErrorColor
                : state === "success"
                ? theme.palette.text.primary
                : theme.palette.primaryDarkBlue,
            borderWidth: "1px",
          },
        },
      }}
      inputProps={{
        "data-testid": `result-${id}`,
        "disabled": true,
        "style": {
          height: "100%",
          color: state === "error" ? theme.palette.cedeErrorColor : theme.palette.text.primary,
        },
      }}
    />
  );
};
